// Assets
import imgAlan from "../assets/img/team/alan.jpeg";
import imgAlexandre from "../assets/img/team/alexandre.jpg";
import imgAntonio from "../assets/img/team/antonio.jpg";
import imgAugusto from "../assets/img/team/augusto.jpg";
import imgBia from "../assets/img/team/bia.jpeg";
import imgBianca from "../assets/img/team/bianca.jpg";
import imgCarlos from "../assets/img/team/carlos.jpeg";
import imgChicao from "../assets/img/team/chicao.jpeg";
import imgChristiano from "../assets/img/team/christiano.jpg";
import imgDavide from "../assets/img/team/davide.jpg";
import imgDornelles from "../assets/img/team/dornelles.jpg";
import imgEduardo from "../assets/img/team/eduardo.jpg";
import imgEnrico from "../assets/img/team/enrico.jpg";
import imgGabrielBit from "../assets/img/team/gabriel_bit.jpeg";
import imgGabrielRauch from "../assets/img/team/gabrielRauch.jpeg";
import imgGuina from "../assets/img/team/guina.jpg";
import imgHamilton from "../assets/img/team/hamilton.jpg";
import imgHenrique from "../assets/img/team/henrique.jpg";
import imgHeron from "../assets/img/team/heron.jpg";
import imgJesus from "../assets/img/team/jesus.jpeg";
import imgJhenny from "../assets/img/team/jhenny.jpeg";
import imgJoaoPedro from "../assets/img/team/joao_pedro.jpg";
import imgJonas from "../assets/img/team/jonas.jpeg";
import imgKaio from "../assets/img/team/kaio.jpeg";
import imgLeomar from "../assets/img/team/leomar.jpeg";
import imgLuan from "../assets/img/team/luan.jpeg";
import imgLucao from "../assets/img/team/lucao.jpg";
import imgLuizGuilherme from "../assets/img/team/luiz_guilherme.jpg";
import imgMaite from "../assets/img/team/maite.jpg";
import imgManao from "../assets/img/team/manao.jpeg";
import imgMatheusAkio from "../assets/img/team/matheus_akio.jpg";
import imgMatheusLima from "../assets/img/team/matheus_lima.jpg";
import imgMatheusJacks from "../assets/img/team/jacks.jpeg";
import imgMarcelo from "../assets/img/team/marcelo.jpg";
import imgMarvin from "../assets/img/team/marvin.jpeg";
import imgNathan from "../assets/img/team/nathan.jpg";
import imgOtavio from "../assets/img/team/otavio.jpg";
import imgPacheco from "../assets/img/team/pacheco.jpeg";
import imgPadilha from "../assets/img/team/padilha.jpeg";
import imgPatrick from "../assets/img/team/patrick.jpeg";
import imgPaulo from "../assets/img/team/paulo.jpg";
import imgRamon from "../assets/img/team/ramon.jpeg";
import imgRaul from "../assets/img/team/raul.jpg";
import imgRodrigo from "../assets/img/team/rodrigo.jpeg";
import imgRomulo from "../assets/img/team/romulo.jpg";
import imgRover from "../assets/img/team/rover.jpeg";
import imgSamady from "../assets/img/team/samady.jpeg";
import imgThiago from "../assets/img/team/thiago.jpeg";
import imgThiagoReis from "../assets/img/team/thiago_reis.jpg";
import imgTomao from "../assets/img/team/tomao.jpg";
import imgVerones from "../assets/img/team/verones.jpeg";
import imgVitao from "../assets/img/team/vitao.jpg";
import imgWillian from "../assets/img/team/willian.jpg";
import imgWiller from "../assets/img/team/willer.jpg";

const membersInfo = {
    "Alan Kunz": {
        name: "Alan Kunz",
        img: imgAlan,
    },
    "Alexandre Mattos": {
        name: "Alexandre Mattos",
        img: imgAlexandre,
    },
    "Ana Beatriz": {
        name: "Ana Beatriz",
        img: imgBia,
    },
    "Antônio Chacarosque": {
        name: "Antônio Chacarosque",
        img: imgAntonio,
    },
    "Augusto Prudencio": {
        name: "Augusto Prudencio",
        img: imgAugusto,
    },
    "Bianca Espíndola": {
        name: "Bianca Espíndola",
        img: imgBianca,
    },
    "Carlos Gomes": {
        name: "Carlos Gomes",
        img: imgCarlos,
    },
    "Christiano Godinho": {
        name: "Christiano Godinho",
        img: imgChristiano,
    },
    "Davide Clode": {
        name: "Davide Clode",
        img: imgDavide,
    },
    "Eduardo Cunha": {
        name: "Eduardo Cunha",
        img: imgEduardo,
    },
    "Enrico Caliolo": {
        name: "Enrico Caliolo",
        img: imgEnrico,
    },
    "Felipe Tomao": {
        name: "Felipe Tomao",
        img: imgTomao,
    },
    "Felipe Verones": {
        name: "Felipe Verones",
        img: imgVerones,
    },
    "Gabriel Bittencourt": {
        name: "Gabriel Bittencourt",
        img: imgGabrielBit,
    },
    "Gabriel Domene": {
        name: "Gabriel Domene",
        img: imgGuina,
    },
    "Gabriel Rauch": {
        name: "Gabriel Rauch",
        img: imgGabrielRauch,
    },
    "Hamilton Batti": {
        name: "Hamilton Batti",
        img: imgHamilton,
    },
    "Henrique Alves": {
        name: "Henrique Alves",
        img: imgHenrique,
    },
    "Heron Pereira": {
        name: "Heron Pereira",
        img: imgHeron,
    },
    "Jhennifer Matias": {
        name: "Jhennifer Matias",
        img: imgJhenny,
    },
    "João Pedro": {
        name: "João Pedro",
        img: imgJoaoPedro,
    },
    "Jonas Negri": {
        name: "Jonas Negri",
        img: imgJonas,
    },
    "Kaio Anselmo": {
        name: "Kaio Anselmo",
        img: imgKaio,
    },
    "Leomar Marschalk": {
        name: "Leomar Marschalk",
        img: imgLeomar,
    },
    "Luan Lorenzo": {
        name: "Luan Lorenzo",
        img: imgLuan,
    },
    "Luan Rodrigues": {
        name: "Luan Rodrigues",
        img: imgManao,
    },
    "Lucas Dornelles": {
        name: "Lucas Dornelles",
        img: imgDornelles,
    },
    "Lucas Steglich": {
        name: "Lucas Steglich",
        img: imgLucao,
    },
    "Luis Filipi": {
        name: "Luis Filipi",
        img: imgJesus,
    },
    "Luiz Guilherme": {
        name: "Luiz Guilherme",
        img: imgLuizGuilherme,
    },
    "Maitê Thomazi": {
        name: "Maitê Thomazi",
        img: imgMaite,
    },
    "Marcelo Keller": {
        name: "Marcelo Keller",
        img: imgMarcelo,
    },
    "Marvin Gasque": {
        name: "Marvin Gasque",
        img: imgMarvin,
    },
    "Matheus Akio": {
        name: "Matheus Akio",
        img: imgMatheusAkio,
    },
    "Matheus Francisco": {
        name: "Matheus Francisco",
        img: imgChicao,
    },
    "Matheus Lima": {
        name: "Matheus Lima",
        img: imgMatheusLima,
    },
    "Matheus Pacheco": {
        name: "Matheus Pacheco",
        img: imgPacheco,
    },
    "Matheus Padilha": {
        name: "Matheus Padilha",
        img: imgPadilha,
    },
    "Matheus Jacks": {
        name: "Matheus Jacks",
        img: imgMatheusJacks,
    },
    "Nathan Marcelino": {
        name: "Nathan Marcelino",
        img: imgNathan,
    },
    "Otávio Moratelli": {
        name: "Otávio Moratelli",
        img: imgOtavio,
    },
    "Patrick Kochan": {
        name: "Patrick Kochan",
        img: imgPatrick,
    },
    "Paulo Duarte": {
        name: "Paulo Duarte",
        img: imgPaulo,
    },
    "Ramon Tramontin": {
        name: "Ramon Tramontin",
        img: imgRamon,
    },
    "Raul Rosá": {
        name: "Raul Rosá",
        img: imgRaul,
    },
    "Rômulo Schiavon": {
        name: "Rômulo Schiavon",
        img: imgRomulo,
    },
    "Rodrigo Guedes": {
        name: "Rodrigo Guedes",
        img: imgRodrigo,
    },
    "Samady Biasoli": {
        name: "Samady Biasoli",
        img: imgSamady,
    },
    "Thiago Raulino": {
        name: "Thiago Raulino",
        img: imgThiago,
    },
    "Thiago Reis": {
        name: "Thiago Reis",
        img: imgThiagoReis,
    },
    "Victor Camargo": {
        name: "Victor Camargo",
        img: imgVitao,
    },
    "Vinícius Rover": {
        name: "Vinícius Rover",
        img: imgRover,
    },
    "Willer Castanheti": {
        name: "Willer Castanheti",
        img: imgWiller,
    },
    "Willian Pizoni": {
        name: "Willian Pizoni",
        img: imgWillian,
    },
};

export default membersInfo;
